import { render, staticRenderFns } from "./BranchServiceUploader.vue?vue&type=template&id=52ea8e9a&"
import script from "./BranchServiceUploader.vue?vue&type=script&lang=ts&"
export * from "./BranchServiceUploader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports